
const iconstyle=""
export const Background ={
    LightBlue:{
        Round:{
            round80:"BackgroundlightBlue CommonRoundBackgroundNoSize iconstyle80"
        },
        Square:{
           square40:"CommonSquareBackgroundNoSize BackgroundlightBlue Icon40" 
        }
    }

}